import { TestId } from "../testIdType"

export const testId: TestId = {
    colorInputContainer: "color-input-container",
    createFromCopy: "create-from-copy",
    createProject: "create-project",
    projectDialogSettingsForm: "project-dialog-settings-form",
    projectGeneralSettingsForm: "project-general-settings-form",
    projectOperatorSettingsForm: "project-operator-settings-form",
    projectStatisticsSettingsForm: "project-statistics-settings-form",
    projectSystemSettingsForm: "project-system-settings-form",
    saveProjectSettings: "save-project-settings",
    wizardStageBackBtn: "wizard-stage-back-btn",
    wizardStageNextBtn: "wizard-stage-next-btn"
}
